import React, { useState, useEffect } from "react";
import Navbar from "../../components/Nav.jsx";
import socketIOClient from "socket.io-client";
import constant from "../../../utils/constants";
import CarbonPolymerProcess from "./components/CarbonPolymerProcess";
import Scenario from "./components/Scenario";
import CurrentReports from "./components/CurrentReports";
import CarbonPolymerCalculator from "./components/CarbonPolymerCalculator";
import "../styles/styles.css";
import "../CarbonCalculator/components/styles.css";
import Analytics from "../Analytics";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRecoilState } from "recoil";
import { HotspotArray, MachineImage, ProcessFlag, ProductionScheduleImage, SingleJobTime, TotalJobs } from "atoms/General";
import ConsultingTeam from "app/components/ConsultingTeam.jsx";
import { Dropdown } from "react-bootstrap";

const CCPolymerSteps = () => {
  const [step, setStep] = useState("process");
  const [socket, setSocket] = useState();
  const [StepID, setSetupID] = useState(0);
  const [processFlag, setProcessFlag] = useRecoilState(ProcessFlag);
  const [email, setEmail] = useState();
  const [typedocument, setTypeDocument] = useState();
  const [show, setShow] = useState(false);
//report 
  const [machineImage, setMachineimage] = useRecoilState(MachineImage);
  const [cppData, setCppData] = useState([]);
  const [totalJobs, setTotalJobs] = useRecoilState(TotalJobs);
  const [singleJobTime, setSingleJobTime] = useRecoilState(SingleJobTime);
  const [psImage, setPsImage] = useRecoilState(ProductionScheduleImage);
  const [cppSum, setcppSum] = useState(0);
  const [hotspotArray, setHotSpotArray] = useRecoilState(HotspotArray);


  useEffect(() => {
    const socketOb = new socketIOClient(constant.uri);
    const patch = require("socketio-wildcard")(socketIOClient.Manager);
    patch(socketOb);
    const socketObj = socketOb;
    setSocket(socketObj);
  }, []);

  // Get the Step Id from the  Carbon Polymer Process...
  const getCarbonPolyerStepID = (stepId) => {
    setSetupID(stepId);
  };

  const getPreviousStep = (current) => {
    if (current === "carbonpricing") return "process";
    if (current === "scenario") return "carbonpricing";
    // if (current === "visual") return "scenario";
    // if (current === "reports") return "visual";
    return "process";
  };

  const getNextStep = (current) => {
    if (current === "process") return "carbonpricing";
    if (current === "carbonpricing") return "scenario";
    if (current === "scenario") return "visual";
    // if (current === "visual") return "reports";
    return current;
  };

  const canProceed = (current) => {
    if (current === "process") return !!processFlag.Transportation;
    if (current === "carbonpricing") return !!processFlag.CarbonPricing;
    if (current === "scenario") return !!processFlag.ScenarioAnalysis;
    // if (current === "visual") return !!processFlag.ScenarioAnalysis;
    else return true;
  };

  const handleBack = () => {
    if (step === "process") {
      window.location.href = "/";
    } else {
      setStep(getPreviousStep(step));
    }
  };

  const handleNext = () => {
    if (canProceed(step)) {
      if (step === "scenario") {
        window.location.href = "/calculator/visual-analytics/true";
      } else {
        setStep(getNextStep(step));
      }
    } else {
      toast.error(`Please fill all ${step} details.`);
    }
  };

  const handleShow = () => setShow(true);
  console.log(processFlag,"processFlag")

  return (
    <React.Fragment>
      <ToastContainer />
      <Navbar />
      <div className="row  ">
        <div className="col page-container px-0">
          <div className="ccsteps-container">
            <div className="bar">
              <div className="row progress-holder "> 
                {/* Process */}
                <div
                  className={
                    "progress-stage deadcenter " +
                    (step === "process" ? " arrow-back" : "")
                  }
                  // onClick={() => {
                  //   setStep("process");
                  // }}
                >
                  <div className="stage ">
                    <img
                      alt=""
                      className="icon-image"
                      id="image-process"
                      src={
                        step === "process"
                          ? "../assets/process-selected.png"
                          : "../assets/process.png"
                      }
                      width="24"
                      height="20"
                    />
                    <p className="d-flex">Process</p>
                  </div>
                </div>

                {/* Carbon Pricing */}
                <div
                  className={
                    "progress-stage deadcenter " +
                    (step === "carbonpricing" ? " arrow-back" : "")
                  }
                  // onClick={() => {
                  //   if (processFlag.Transportation) {
                  //     setStep("carbonpricing");
                  //   } else {
                  //     toast.error("Please fill all process details.");
                  //   }
                  // }}
                >
                  <div className="stage ">
                    <img
                      alt=""
                      className="icon-image"
                      id="image-carbonpricing"
                      src={
                        step === "carbonpricing"
                          ? "../assets/carbon-selected.png"
                          : "../assets/carbon.png"
                      }
                      width="24"
                      height="20"
                    />
                    <p className="d-flex">Carbon Pricing</p>
                  </div>
                </div>

                {/* Scenarios */}
                <div
                  className={
                    "progress-stage deadcenter " +
                    (step === "scenario" ? " arrow-back" : "")
                  }
                  // onClick={() => {
                  //   if (processFlag.ScenarioAnalysis) {
                  //     setStep("visual");
                  //   } else {
                  //     toast.error("Please fill all scenario analysis details.");
                  //   }
                  // }}
                >
                  <div className="stage ">
                    <img
                      alt=""
                      className="icon-image"
                      id="image-scenario"
                      src={
                        step === "scenario"
                          ? "../assets/scenarios-selected.png"
                          : "../assets/scenarios.png"
                      }
                      width="24"
                      height="20"
                    />
                    <p className="d-flex">Scenarios</p>
                  </div>
                </div>

                {/* Visual Analytics */}
                {/* <div
                  className={
                    "progress-stage deadcenter " +
                    (step === "visual" ? " arrow-back" : "")
                  }
                  onClick={() => {
                    if (processFlag.ScenarioAnalysis) {
                      setStep("visual");
                    } else {
                      toast.error("Please fill all scenario analysis details.");
                    }
                  }}
                >
                  <div className="stage ">
                    <img
                      alt=""
                      className="icon-image"
                      id="image-visual"
                      src={
                        step === "visual"
                          ? "../assets/analytics.png"
                          : "../assets/analytics.png"
                      }
                      width="24"
                      height="20"
                    />
                    <p className="d-flex">Visual Analytics</p>
                  </div>
                </div> */}

                {/* Reports */}
                {/* <div
                  className={
                    "progress-stage deadcenter " +
                    (step === "reports" || step === "reportstwo"
                      ? " arrow-back"
                      : "")
                  }
                  onClick={() => {
                    if (processFlag.ScenarioAnalysis) {
                      setStep("reports");
                    } else {
                      toast.error("Please fill all visual analytics details.");
                    }
                  }}
                >
                  <div className="stage ">
                    <img
                      alt=""
                      className="icon-image"
                      id="image-reports"
                      src={
                        step === "reports" || step === "reportstwo"
                          ? "../assets/report-selected.png"
                          : "../assets/report1.png"
                      }
                      width="24"
                      height="20"
                    />
                    <p className="d-flex">Reports</p>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="container-form row p-0" style={{
              minHeight:"calc(100vh - 291px)"
            }}>
            {step === "process" && (
              <CarbonPolymerProcess
                socket={socket}
                getCarbonPolyerStepID={getCarbonPolyerStepID}
                ScenarioState={() => setStep("carbonpricing")}
              />
            )}
            {step === "scenario" && (
              <Scenario
                socket={socket}
                ScenarioState={() => setStep("visual")}
              />
            )}
            {step === "visual" && (
              <Analytics
                ScenarioState={() => setStep("reports")}
                socket={socket}
              />
            )}
            {step === "reports" && (
              <CurrentReports
                socket={socket}
                setEmail={setEmail}
                setTypeDocument={setTypeDocument}
                typedocument={typedocument}
                ScenarioState={() => setStep("reportstwo")}
                setShow={setShow}
                show={show}
                email={email}
                setMachineimage={setMachineimage}
                machineImage={machineImage}
                cppData={cppData}
                setCppData={setCppData}
                totalJobs={totalJobs}
                setTotalJobs={setTotalJobs}
                setSingleJobTime={setSingleJobTime}
                singleJobTime={singleJobTime}
                psImage={psImage}
                setPsImage={setPsImage}
                setcppSum={setcppSum}
                cppSum={cppSum}
                setHotSpotArray={setHotSpotArray}
                hotspotArray={hotspotArray}
                
              />
            )}
            {step === "carbonpricing" && (
              <CarbonPolymerCalculator
                socket={socket}
                StepID={StepID}
                ScenarioState={() => setStep("scenario")}
              />
            )}
            </div>

            <div className="border-top mt-24">
              <div className="d-flex mx-80 my-12   justify-content-between">
                <>
                  <div className="d-flex ">
                    <div id="btn-row ">
                      <div
                        className="button1 button btn-black"
                        onClick={handleBack}
                      >
                        <p>Back</p>
                      </div>
                    </div>
                  </div>
                  {step==="reports"?(
                    <div className="d-flex justify-content-center align-items-center gap-8">
                    <Dropdown>
                      <Dropdown.Toggle
                        className="button1 button btn-black "
                        id="dropdown-basic"
                        style={{backgroundColor:"black"}}
                      >
                       <div className='d-flex gap-8'>
                          <img alt=""  src="../assets/download.svg" />
                          <span>Download</span>
                          </div>
                      </Dropdown.Toggle>
          
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => {
                            setTypeDocument(0);
                            handleShow()
                          }}
                        >
                          As Pdf
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setTypeDocument(1);
                            handleShow()
                          }}
                        >
                          As Word
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <ConsultingTeam navigate={email} />

                  </div>
                  ):(
                  
                  <div>
                    <div id="btn-row">
                      <div
                        className="button1 button btn-primary"
                        onClick={handleNext}
                      >
                        <p>Next</p>
                      </div>
                    </div>
                  </div>
                  )}
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CCPolymerSteps;
